import { useAppDispatch, useAppSelector } from "../../redux/store"
import { Link, useNavigate } from "react-router-dom"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useForm } from "react-hook-form"
import Button from "react-bootstrap/Button"
import { loginEmail, setError } from "../../redux/slices/auth/authSlice"
import Field from "./utils/Field"
import LoginGoogle from "./LoginGoogle"
import LoginApple from "./LoginApple"
import { ToastContainer, toast } from "react-toastify"

interface IForm {
  email: string
  password: string
}

export const Login = () => {
  const { t } = useTranslation()
  const { error, status } = useAppSelector((state) => state.auth)
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    clearErrors,
    control,
    formState: { errors },
  } = useForm<IForm>({})

  const dispatch = useAppDispatch()

  const onSubmit = async () => {
    let data = {
      email,
      password,
    }

    const result = await dispatch(loginEmail(data)) // Wait for dispatch to complete

    if (result?.type === "authorization/loginEmail/rejected") {
      toast.error("Incorrect Credentials")
    }

    if (result?.type === "authorization/loginEmail/fulfilled") {
      navigate("/")
    }
  }

  const clearErrorsField = () => {
    if (error) {
      dispatch(setError(""))
    }

    clearErrors()
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (
      ((event.target as HTMLInputElement).name === "password" ||
        (event.target as HTMLInputElement).name === "email") &&
      event.key === "Enter"
    ) {
      onSubmit()
    }
  }

  return (
    <>
      <form
        className="login-form"
        onSubmit={handleSubmit(onSubmit)}
        onKeyDown={handleKeyDown}
      >
        <Field
          name="email"
          type="email"
          placeholder={t("placeholder.email")}
          value={email}
          error={errors.email?.message || error}
          register={register}
          onHandleChange={(value) => {
            clearErrorsField()
            setEmail(value)
          }}
        />
        <Field
          name="password"
          type="password"
          placeholder={t("placeholder.password")}
          value={password}
          error={errors.password?.message || error}
          register={register}
          onHandleChange={(value) => {
            clearErrorsField()
            setPassword(value)
            console.log(value)
          }}
        />
        {/* <div className="input-item__controls d-flex justify-content-end">
        <Link
          to={status !== "FORGOT-PASSWORD-SUCCESS" ? "/forgot-password" : ""}
        >
          {t("base.linkForgot")}
        </Link>
      </div> */}
        <div className="login__controls mt-sm-4">
          <Button
            type="submit"
            variant="btn btn w-100"
            style={{ backgroundColor: "#245192", color: "#ffffff" }}
          >
            {t("buttons.signIn")}
          </Button>
        </div>
        <span className="politic-text d-flex  ">
          <Link
            to="https://blog.mazoom.sa/terms"
            className="d-flex"
            style={{ textDecoration: "none" }}
          >
            {/* {" "}
          <span className="w-full" style={{ width: "172px" }}>
            {t("login.politic.text")}
          </span>
          <span style={{ textDecoration: "underline" }}>
            {t(
              "login.politic.termsOfUseAndAcknowledgeThePrivacyPolicyAndCookiePolicy",
            )}
          </span> */}
          </Link>{" "}
          {/* {t("login.politic.textAnd")}
        <Link target="_blank" to="https://blog.mazoom.sa/privacy-policy">
          {t("login.politic.textLinkPrivacyPolicy")}
        </Link> */}
        </span>
        <div className="login-text d-flex justify-content-center p-sm-4 gap-1">
          <h6 className="text-muted d-flex flex-row algin-items-center">
            {" "}
            {t("login.text")}
            <span
              className=""
              style={{
                marginLeft: "10px",
                textDecoration: "underline",
              }}
            >
              {" "}
              <Link to="/signup" style={{ color: "red" }}>
                {" "}
                {t("buttons.signUp")}
              </Link>
            </span>
          </h6>
        </div>
        <div className="alternate-login">
          <div className="bl-or">
            <span>{t("base.or")}</span>
          </div>

          <LoginGoogle />

          <Link to="/whatsapp" className="link-login link-login--whatsapp">
            <span className="link-login__text">WhatsApp</span>
          </Link>
        </div>
      </form>
      {/* <ToastContainer
        style={{ width: "90%", maxWidth: "400px", fontSize: "18px" }}
      />{" "} */}
    </>
  )
}

export default Login
